import { useTourDetailsList } from '../../../../property_tour_availability/hooks/useTourDetailsList';

export const useTourAvailability = (nhID: number) => {
    const { data, isLoading } = useTourDetailsList();
    
    const tourDetails = data?.rows?.find((row: any) => row.NHID === nhID);

    return { tourDetails, isLoading };
}; 